import {
  Dialog, DialogActions, DialogTitle, DialogContent, DialogContentText, Button, Grid
} from '@material-ui/core';
import React from 'react';

const ConfirmDeleteDialog = ({ book, open, handleClose, handleConfirm }) => {
  return (
    <Dialog
      open={ open }
      onClose={ handleClose }
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle
        id='alert-dialog-title'>{ 'Tem certeza que deseja remover o livro selecionado?' }</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <Grid container spacing={3}>
            <Grid item>
            { book?.cover_url ? <img src={ book.cover_url } height={ 100 } /> : '' }
            </Grid>
            <Grid item>
              {book?.title}
              <br />
              {book?.authors}
              <br />
              {book?.isbn13}
            </Grid>
          </Grid>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={ handleClose } color='primary'>
          Não
        </Button>
        <Button onClick={() => handleConfirm(book)} color='primary' autoFocus>
          Sim
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteDialog;
